var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts_wrap"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.el.title))]),_c('div',{ref:"wrapper",staticClass:"basic-pie"})])
}
var staticRenderFns = []

export { render, staticRenderFns }